<template>
  <q-pagination
      :modelValue="items.current_page"
      :max="items.last_page"
      direction-links
      unelevated
      color="neutral-90"
      active-color="primary"
      @update:modelValue="navigateToPage"
      :input="mini"
      boundary-numbers
  />
</template>

<script>

export default {
  props: {
    items: {
      type: Object,
      required: true,
    },
    mini: {
      type: Boolean,
      default: true,
    },
    pageKey: {
      type: String,
      default: 'page',
    },
  },
  methods: {
    navigateToPage (page) {
      if (this.$attrs.onNavigate) {
        this.$emit('navigate', page)
        return
      }
      const searchParams = new URLSearchParams(window.location.search)
      searchParams.set(this.pageKey, page)
      window.location.href = `${window.location.origin}${window.location.pathname}?${searchParams.toString()}`
    },
  },
}
</script>
